<template>
  <div class="container notFoundScreen">
    <div class="notFoundScreen__notFound">
      <span class="notFoundScreen__marker"></span>
      <h2 class="notFoundScreen__title">Booking not found</h2>
      <p class="notFoundScreen__text">
        Please contact the hotel if you think <br />
        an error has occurred
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFoundScreen",
};
</script>

<style lang="scss">
.notFoundScreen {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.notFoundScreen__notFound {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 275px;
  width: 100%;
}

.notFoundScreen__marker {
  width: 72.5px;
  height: 72.5px;
  display: block;
  background-repeat: no-repeat;
  background-image: url("data:image/svg+xml,%3Csvg width='73' height='74' viewBox='0 0 73 74' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M36.5 0.75C26.8125 0.75 17.6875 4.5 10.875 11.375C4 18.1875 0.25 27.3125 0.25 37C0.25 46.6875 4 55.8125 10.875 62.625C17.75 69.5 26.8125 73.25 36.5 73.25C46.1875 73.25 55.3125 69.5 62.125 62.625C69 55.75 72.75 46.6875 72.75 37C72.75 27.3125 69 18.1875 62.125 11.375C55.3125 4.5 46.1875 0.75 36.5 0.75ZM36.5 4.5C45.1875 4.5 53.313 7.87451 59.5005 13.9995C65.688 20.1245 69 28.3125 69 37C69 45.6875 65.6255 53.813 59.5005 60.0005C53.313 66.1255 45.1875 69.5 36.5 69.5C27.8125 69.5 19.687 66.1255 13.4995 60.0005C7.31201 53.8755 4 45.6875 4 37C4 28.3125 7.37451 20.187 13.4995 13.9995C19.6245 7.81201 27.8125 4.5 36.5 4.5ZM28.1016 26.6875C27.625 26.6875 27.1562 26.8752 26.8125 27.2502C26.0625 28.0002 26.0625 29.1873 26.8125 29.8748L33.8755 37L26.7502 44.063C26.0002 44.813 26.0002 46 26.7502 46.6875C27.1252 47.0625 27.625 47.2502 28.0625 47.2502C28.5 47.2502 28.9998 47.0625 29.3748 46.6875L36.5 39.6245L43.563 46.6875C43.938 47.0625 44.4377 47.2502 44.8752 47.2502C45.3127 47.2502 45.8125 47.0625 46.1875 46.6875C46.9375 45.9375 46.9375 44.7505 46.1875 44.063L39.1245 37L46.1875 29.937C46.9375 29.187 46.9373 28.0002 46.2498 27.2502C45.4998 26.5002 44.3127 26.5002 43.6252 27.2502L36.5 34.3755L29.437 27.2502C29.062 26.8752 28.5781 26.6875 28.1016 26.6875Z' fill='white'/%3E%3C/svg%3E%0A");
  margin-bottom: 23.75px;
  background-size: contain;
}

.notFoundScreen__title {
  font-weight: 500;
  font-size: 20px;
  line-height: 25px;
  margin-bottom: 10px;
  color: var(--color-text);
  width: 100%;
  text-align: center;
}

.notFoundScreen__text {
  font-weight: 400;
  font-size: 15px;
  line-height: 140%;
  color: #ffffff;
  opacity: 0.5;
  text-align: center;
  margin-bottom: 0;
  width: 100%;
}

@include media-breakpoint-up(sm) {
  .notFoundScreen__notFound {
    max-width: 480px;
  }
}
</style>
